export enum ConnectionStatusEnum {
    Online,
    Offline
}
